import {IUsuarioFiltersDto} from "@models/conta/IUsuarioFiltersDto.ts";
import {DefaultFilterPageProps} from "@models/DefaultFilterPageProps.ts";
import React, {useState} from "react";
import {Button, FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";
import {CheckOutlined} from "@mui/icons-material";
import {fullHeight} from "@models/helpers.ts";

interface UsuarioFiltersPageProps extends DefaultFilterPageProps<IUsuarioFiltersDto> {
}

export function UsuarioFiltersPage(props: UsuarioFiltersPageProps) {
    const {filters, setFilters, onApply} = props;
    const [value, setValue] = useState<IUsuarioFiltersDto>({...filters});

    const handleAplicar = () => {
        if (setFilters != null)
            setFilters(value);
        if (onApply != null)
            onApply();
    }

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleAplicar();
        }
    }

    // local text state for IDs input (comma-separated), allows typing commas and intermediate states
    const [idsInput, setIdsInput] = useState<string>(() => (filters?.ids && filters.ids.length > 0 ? filters.ids.join(',') : ''));

    return (
        <Grid container>
            <Grid container size={12} mb={1} justifyContent={'space-between'}>
                <Grid/>
                <Grid>
                    <Button fullWidth
                            onClick={handleAplicar}
                            disabled={JSON.stringify(value) === JSON.stringify(filters)}
                            color={'success'}
                            sx={{...fullHeight}}
                            endIcon={<CheckOutlined/>}>Aplicar</Button>
                </Grid>
            </Grid>

            <Grid size={{
                sm: 12,
                md: 12,
            }}>
                <TextField label={'IDs (separados por vírgula)'}
                           fullWidth
                           value={idsInput}
                           onKeyDown={handleEnter}
                           onChange={(e) => {
                               const text = e.target.value;
                               setIdsInput(text);
                               const parts = text.split(',').map(x => x.trim()).filter(x => x.length > 0);
                               const nums = parts.map(p => Number(p)).filter(n => !Number.isNaN(n));
                               setValue({...value, ids: nums.length > 0 ? nums : undefined});
                           }}/>
            </Grid>

            <Grid size={{
                sm: 12,
                md: 6,
            }}>
                <TextField label={'Nome'}
                           fullWidth
                           onKeyDown={handleEnter}
                           value={value.nome ?? ''}
                           onChange={(e) => setValue({...value, nome: e.target.value})}/>
            </Grid>

            <Grid size={{
                sm: 12,
                md: 6,
            }}>
                <TextField label={'Email'}
                           fullWidth
                           onKeyDown={handleEnter}
                           value={value.email ?? ''}
                           onChange={(e) => setValue({...value, email: e.target.value})}/>
            </Grid>

            <Grid size={{
                xs: 12,
                md: 6,
            }}>
                <DefaultDatePicker label={'Logou Início'}
                                   value={value.logouInicio || null}
                                   catchValue={(d) => setValue({...value, logouInicio: d})}/>
            </Grid>
            <Grid size={{
                xs: 12,
                md: 6,
            }}>
                <DefaultDatePicker label={'Logou Fim'}
                                   value={value.logouFim || null}
                                   catchValue={(d) => setValue({...value, logouFim: d})}/>
            </Grid>

            <Grid container>
                <FormControlLabel control={<Switch checked={value.ativo ?? false}
                                                   onChange={(e) => setValue({...value, ativo: e.target.checked})}/>}
                                  label={'Ativo'}/>
            </Grid>
        </Grid>
    );
}